import React from "react";

export interface BoxProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  label?: string;
  dimmed?: boolean;
  opacity?: number;
}

export const Box: React.FC<BoxProps> = ({ x = 10, y = 10, width = 120, height = 60, label, dimmed, opacity = 1 }) => {
  const fill = dimmed ? "#1e293b" : "#1e3a8a";
  const textColor = dimmed ? "#9ca3af" : "#f9fafb";

  return (
    <g opacity={opacity}>
      <rect x={x} y={y} width={width} height={height} rx={8} ry={8} fill={fill} stroke="#0f172a" strokeWidth={2} />
      {label && (
        <text x={x + width / 2} y={y + height / 2} fill={textColor} textAnchor="middle" dominantBaseline="middle">
          {label}
        </text>
      )}
    </g>
  );
};
